import { render, staticRenderFns } from "./InvoiceCreationSlider.vue?vue&type=template&id=4586bc2a&scoped=true&"
import script from "./InvoiceCreationSlider.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCreationSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586bc2a",
  null
  
)

export default component.exports